import { Controller } from "@hotwired/stimulus"

// Tracks screen size and dispatches events for Alpine components
// Handles resize listener with proper cleanup
export default class extends Controller {
  static values = { breakpoint: { type: Number, default: 1024 } }

  connect() {
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
    // Initial check
    this.handleResize()
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    const isSmallScreen = window.innerWidth < this.breakpointValue
    // Dispatch custom event for Alpine to listen to
    this.dispatch("change", { detail: { isSmallScreen } })
  }
}
